import React from 'react';
import { toast } from 'sonner';

const SportSelector = ({
    sports = [],
    selectedSports = [],
    onToggleSport,
    maxSports = 3,
    disabled = false
}) => {
    const handleToggle = (sport) => {
        if (disabled) return;
        
        if (selectedSports.includes(sport)) {
            onToggleSport(selectedSports.filter(s => s !== sport));
        } else {
            if (selectedSports.length >= maxSports) {
                toast.error(`Maximum ${maxSports} sports allowed`);
                return;
            }
            onToggleSport([...selectedSports, sport]);
        }
    };

    return (
        <div className="space-y-2">
            <label className="text-xs tracking-widest uppercase text-muted-foreground">
                Sport(s) * {maxSports < 10 && `(Max ${maxSports})`}
            </label>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
                {sports.map((sport) => (
                    <div
                        key={sport}
                        onClick={() => handleToggle(sport)}
                        className={`p-3 text-sm cursor-pointer border transition-all ${
                            selectedSports.includes(sport)
                                ? 'bg-primary/20 border-primary text-white'
                                : 'bg-[#0a1628] border-white/10 text-muted-foreground hover:border-white/30'
                        } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                        data-testid={`sport-option-${sport.toLowerCase().replace(/\s+/g, '-')}`}
                    >
                        {sport}
                    </div>
                ))}
            </div>
            {selectedSports.length > 0 && (
                <p className="text-xs text-primary">{selectedSports.length} sport(s) selected</p>
            )}
        </div>
    );
};

export default SportSelector;
